import { Paper, Stack, TextField, Button, MenuItem, FormControlLabel, Checkbox, Typography, FormHelperText } from '@mui/material';
import Search from '@mui/icons-material/Search';
import CategorySelect from './CategorySelect';

const SearchForm = ({
  searchQuery,
  searchFields,
  handleSearchChange,
  handleSearchSubmit,
  handleClearSearch,
  categories,
  children,
}) => (
  <Paper variant='section'>
    <Stack spacing={2}>
      {/* ヘッダー */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Search color="primary" />
        <Typography component="h2" variant="h4">検索する</Typography>
      </Stack>

      <form autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          handleSearchSubmit();
        }}
      >
        <Stack spacing={1.5}>
          {searchFields.map((field) => (
            <Stack key={field.name} spacing={1}>
              {field.type === 'checkbox' ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={searchQuery[field.name] || false}
                      onChange={handleSearchChange}
                      name={field.name}
                    />
                  }
                  label={field.label}
                />
              ) : field.type === 'date' ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <TextField
                    name="startDate"
                    label="開始日"
                    type="date"
                    value={searchQuery.startDate || ''}
                    size="small"
                    onChange={handleSearchChange}
                    InputLabelProps={{ shrink: true }}
                  />
                  <span>～</span>
                  <TextField
                    name="endDate"
                    label="終了日"
                    type="date"
                    value={searchQuery.endDate || ''}
                    size="small"
                    onChange={handleSearchChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Stack>
              ) : field.type === 'textarea' ? (
                <TextField
                  name={field.name}
                  label={field.label}
                  multiline
                  minRows={2}
                  value={searchQuery[field.name] || ''}
                  size="small"
                  onChange={handleSearchChange}
                  placeholder={field.placeholder || ''}
                />
              ) : field.type === 'select' ? (
                field.name === 'category_id' ? (
                  <CategorySelect
                    categories={categories}
                    selectedCategory={searchQuery.category_id || ''}
                    setSelectedCategory={(value) =>
                      handleSearchChange({ target: { name: field.name, value } })
                    }
                    size='small'
                  />
                ) : (
                  <TextField
                    name={field.name}
                    select
                    label={field.label}
                    value={searchQuery[field.name] || ''}
                    size="small"
                    onChange={handleSearchChange}
                  >
                    <MenuItem value="">選択してください</MenuItem>
                    {field.options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )
              ) : (
                <TextField
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  value={searchQuery[field.name] || ''}
                  size="small"
                  onChange={handleSearchChange}
                />
              )}
            </Stack>
          ))}
          {children}
          {/* ボタン */}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={handleSearchSubmit}
            >
              検索
            </Button>
            <Button variant="outlined" onClick={handleClearSearch}>
              クリア
            </Button>
          </Stack>
        </Stack>
      </form>
    </Stack>
  </Paper>
);

export default SearchForm;
